import { Sparkles } from 'lucide-react';

/** Ava's mark in the patient portal, in the clinic's own portal colours. `busy` while she's working. */
export function AvaMark({ size = 36, busy = false }: { size?: number; busy?: boolean }) {
  return <span aria-hidden="true" className="relative grid shrink-0 place-items-center rounded-full bg-[conic-gradient(from_210deg,var(--portal-accent),var(--portal-tint-3),var(--portal-tint-1),var(--portal-accent))] text-white shadow-[0_6px_16px_-8px_rgba(36,26,21,0.5)]" style={{ width: size, height: size }}>
    {busy && <span className="absolute inset-0 rounded-full bg-[var(--portal-accent)] opacity-30 motion-safe:animate-ping" />}
    <Sparkles className="relative h-[45%] w-[45%] drop-shadow" />
  </span>;
}
